import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Increased fossil fuel demand coupled with the dwindling stock and
              concerns of global warming has necessitated the exploration of
              environmentally sustainable, renewable and economically viable
              alternatives to cater to the growing demand for liquid fuel in the
              transportation and industries sectors. The availability of the
              abundant residues of rice (43.86 MT) and wheat (25.07 MT) in India
              necessitates sustainable utilization for the production of
              bioethanol to minimize instances of stubble burning. India
              produces large quantities of rice and wheat residues;
              bioconversion of these residues into biofuels will aid in prudent
              waste management. The prospects of utilising marine bacterial
              strain <em>V. parahaemolyticus</em> for enzyme hydrolysis and
              yeast strain <em>P. kudriavzevii </em>for fermentation is explored
              in the bioethanol production process. Simultaneous
              saccharification and fermentation of paddy straw produced 0.28 g/g
              of ethanol with a conversion efficiency of 76.62%, and wheat straw
              produced 0.42 g/g of ethanol with a conversion efficiency of
              64.82%. The study highlights that biofuel production from
              lignocellulosic biomass is eco-friendly and cost-effective,
              considering the need for energy and environmental security with
              the optimal use of agro-wastes hitherto being burnt in most parts
              of Asian countries contributing to air pollution with the
              associated health impacts. Utilization of Paddy and wheat straw
              will likely produce ethanol of 30-60 L per 100 kg of biomass. The
              surplus biomass residue generation in every state and its
              bioethanol production potential helps in evolving appropriate
              strategies for operationalizing biofuel production units across
              India. Utilizing the hitherto wasted abundant resources of
              bio-residues for valuable products is quintessential for lowering
              the carbon footprint associated with mismanagement.
            </p>
            <p>
              <br />
              <br />
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
